import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab11',
  templateUrl: './awsop-lab11.component.html',
  styleUrls: ['./awsop-lab11.component.css']
})
export class AwsopLab11Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab11/awsop-lab11.component.ts